import { GameState } from '../game/GameState';
import { DataRegistry } from './DataRegistry';
import { ModifierManager } from './ModifierManager';

export class SupplyManager {
  static readonly instance = new SupplyManager();

  provinceSupplyCapacity(provinceId: string) {
    const campaign = GameState.instance.requireCampaign();
    const province = campaign.provinces[provinceId];
    const provinceData = DataRegistry.instance.provinces[provinceId];
    if (!province || !provinceData) return 0;
    const modifiers = ModifierManager.instance.forFaction(province.owner);
    return 8 + modifiers.supplyCapacityBonus + (province.supplyDepot ? 15 : 0) + (provinceData.port ? 8 + (province.portLevel ?? 0) * 4 : 0) + (province.roadLevel ?? 0) * (5 + modifiers.roadSupplyBonus);
  }

  processMonth() {
    const campaign = GameState.instance.requireCampaign();
    for (const province of Object.values(campaign.provinces)) {
      const made = Math.min(30, Math.floor((province.storage.rice ?? 0) / 3) + Math.floor((province.storage.fish ?? 0) / 2));
      if (made > 0) {
        province.storage.rice = Math.max(0, (province.storage.rice ?? 0) - Math.ceil(made / 2));
        province.storage.fish = Math.max(0, (province.storage.fish ?? 0) - Math.floor(made / 2));
        province.storage.rations = (province.storage.rations ?? 0) + made;
      }
    }

    for (const army of Object.values(campaign.armies)) {
      const sourceProvince = campaign.provinces[army.supplySource ?? army.provinceId];
      if (!sourceProvince) continue;
      const need = army.units.reduce((sum, stack) => sum + (DataRegistry.instance.units[stack.unitId]?.supply ?? 1), 0);
      const capacity = this.provinceSupplyCapacity(sourceProvince.id);
      const effectiveNeed = Math.max(0, need - capacity);
      const fed = Math.min(sourceProvince.storage.rations ?? 0, effectiveNeed);
      sourceProvince.storage.rations = Math.max(0, (sourceProvince.storage.rations ?? 0) - fed);
      if (fed < effectiveNeed) {
        for (const stack of army.units) {
          stack.morale = Math.max(1, stack.morale - 2);
          stack.strength = Math.max(0, stack.strength - 3);
        }
        GameState.instance.log(`${army.id} suffers attrition from poor supply.`, 'warning');
      } else if (need > 0) {
        for (const stack of army.units) stack.morale = Math.min((DataRegistry.instance.units[stack.unitId]?.morale ?? 50) + 10, stack.morale + 1);
      }
    }
  }
}
